module.exports = __webpack_public_path__ + "static/media/Screenshot_3-thumb.be5e4998.png";